// Static UI translations. Customer-submitted messages are auto-translated via /api/translate.
import { createContext, useContext, useEffect, useState, useCallback } from "react";

export const LANGS = [
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "es", label: "Español", flag: "🇲🇽" },
  { code: "zh-CN", label: "简体中文", flag: "🇨🇳" },
  { code: "zh-TW", label: "繁體中文", flag: "🇹🇼" },
  { code: "ko", label: "한국어", flag: "🇰🇷" },
  { code: "vi", label: "Tiếng Việt", flag: "🇻🇳" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
];

const T = {
  en: {
    nav: { home: "Home", services: "Services", brands: "Brands", pricing: "Pricing", specials: "Specials", projects: "Projects", reviews: "Reviews", areas: "Service Areas", about: "About", schedule: "Schedule", contact: "Contact" },
    cta: { call: "Call Now", schedule: "Schedule Service", estimate: "Get Free Estimate", text: "Text Us" },
    hero: { h1: "FAST. RELIABLE REPAIRS & INSTALLATIONS.", sub: "Local. Insured. Expert Techs. Free Estimates.", badges: ["Licensed & Insured","Same-Day Service","Emergency Available","Residential & Commercial"] },
    emergency: "24/7 Emergency HVAC Service Available",
    emergency_sub: "No call-out fees after hours.",
    why: { title: "Why Choose AIR-COLD HVAC", sub: "Premium service. Honest pricing. Real people who answer the phone." },
    services: { title: "Services", sub: "Whole-home and commercial HVAC — done right the first time." },
    brands: { title: "All Major HVAC Brands", sub: "We install, repair, and service every major HVAC brand." },
    pricing: { title: "Transparent Equipment Pricing", sub: "No Hidden Pricing. Know Your Equipment Options Before You Call." },
    estimate: { title: "Instant Estimate", sub: "Tell us about your home and get a price range in seconds." },
    projects: { title: "Recent Projects", sub: "Real installs and repairs across Southern California." },
    reviews: { title: "Customer Reviews", sub: "Real feedback from Southern California homeowners." },
    specials: { title: "Special Offers", sub: "Limited-time promotions on installations, repairs, and maintenance." },
    membership: { title: "Maintenance Membership", sub: "Priority service. Lower bills. Longer system life." },
    areas: { title: "Service Areas", sub: "Proudly serving Southern California — and likely your neighborhood." },
    faq: { title: "Frequently Asked Questions" },
    contact: { title: "Get In Touch", sub: "Call, text, or fill out a form — we respond fast." },
  },
  es: {
    nav: { home: "Inicio", services: "Servicios", brands: "Marcas", pricing: "Precios", specials: "Ofertas", projects: "Proyectos", reviews: "Reseñas", areas: "Zonas", about: "Nosotros", schedule: "Reservar", contact: "Contacto" },
    cta: { call: "Llamar Ahora", schedule: "Reservar Servicio", estimate: "Estimado Gratis", text: "Envíanos un SMS" },
    hero: { h1: "RÁPIDO. REPARACIONES E INSTALACIONES CONFIABLES.", sub: "Local. Asegurado. Técnicos expertos. Estimados gratis.", badges: ["Licencia y Seguro","Servicio el Mismo Día","Emergencias 24/7","Residencial y Comercial"] },
    emergency: "Servicio HVAC de Emergencia 24/7 Disponible",
    emergency_sub: "Sin cargos por llamadas fuera de horario.",
    why: { title: "¿Por qué elegir AIR-COLD HVAC?", sub: "Servicio premium. Precios honestos. Personas reales al teléfono." },
    services: { title: "Servicios", sub: "HVAC residencial y comercial — bien hecho la primera vez." },
    brands: { title: "Todas las Marcas HVAC", sub: "Instalamos, reparamos y mantenemos todas las marcas." },
    pricing: { title: "Precios Transparentes de Equipos", sub: "Sin Precios Ocultos. Conoce tus opciones antes de llamar." },
    estimate: { title: "Estimado Instantáneo", sub: "Cuéntanos sobre tu hogar y recibe un rango de precio." },
    projects: { title: "Proyectos Recientes", sub: "Instalaciones reales en el sur de California." },
    reviews: { title: "Reseñas de Clientes", sub: "Comentarios reales de propietarios del sur de California." },
    specials: { title: "Ofertas Especiales", sub: "Promociones por tiempo limitado." },
    membership: { title: "Membresía de Mantenimiento", sub: "Servicio prioritario. Cuentas más bajas. Sistemas más duraderos." },
    areas: { title: "Zonas de Servicio", sub: "Servimos con orgullo todo el sur de California." },
    faq: { title: "Preguntas Frecuentes" },
    contact: { title: "Contáctanos", sub: "Llama, manda SMS o llena un formulario — respondemos rápido." },
  },
  "zh-CN": {
    nav: { home: "主页", services: "服务", brands: "品牌", pricing: "价格", specials: "优惠", projects: "项目", reviews: "评价", areas: "服务区", about: "关于", schedule: "预约", contact: "联系" },
    cta: { call: "立即致电", schedule: "预约服务", estimate: "免费报价", text: "发短信" },
    hero: { h1: "快速。可靠的维修与安装。", sub: "本地。有保险。专业技师。免费报价。", badges: ["持牌投保","当天上门","24/7 应急","住宅及商业"] },
    emergency: "24/7 紧急 HVAC 服务",
    emergency_sub: "下班后无上门费。",
    why: { title: "为何选择 AIR-COLD HVAC", sub: "优质服务，诚实定价，真人接听。" },
    services: { title: "服务项目", sub: "住宅与商用 HVAC，一次做好。" },
    brands: { title: "所有主要 HVAC 品牌", sub: "我们安装、维修和保养所有主要品牌。" },
    pricing: { title: "透明的设备价格", sub: "价格公开透明。致电前先了解设备选项。" },
    estimate: { title: "即时报价", sub: "告诉我们您家的情况，几秒获得价格范围。" },
    projects: { title: "近期项目", sub: "南加州真实的安装与维修案例。" },
    reviews: { title: "客户评价", sub: "南加州业主的真实反馈。" },
    specials: { title: "特别优惠", sub: "限时促销活动。" },
    membership: { title: "保养会员", sub: "优先服务，更省电费，更长寿命。" },
    areas: { title: "服务区域", sub: "服务整个南加州。" },
    faq: { title: "常见问题" },
    contact: { title: "联系我们", sub: "电话、短信或表单 — 我们快速响应。" },
  },
  "zh-TW": {
    nav: { home: "主頁", services: "服務", brands: "品牌", pricing: "價格", specials: "優惠", projects: "項目", reviews: "評價", areas: "服務區", about: "關於", schedule: "預約", contact: "聯絡" },
    cta: { call: "立即來電", schedule: "預約服務", estimate: "免費估價", text: "傳送簡訊" },
    hero: { h1: "快速。可靠的維修與安裝。", sub: "本地。有保險。專業技師。免費估價。", badges: ["持牌投保","當天到府","24/7 緊急","住宅及商用"] },
    emergency: "24/7 緊急 HVAC 服務",
    emergency_sub: "下班後無到府費。",
    why: { title: "為何選擇 AIR-COLD HVAC", sub: "頂級服務，誠實定價，真人接聽。" },
    services: { title: "服務項目", sub: "住宅與商用 HVAC，一次做到位。" },
    brands: { title: "所有主要 HVAC 品牌", sub: "我們安裝、維修並保養所有主要品牌。" },
    pricing: { title: "透明的設備價格", sub: "價格透明。來電前先了解設備選項。" },
    estimate: { title: "即時估價", sub: "告訴我們您家的情況，幾秒取得價格範圍。" },
    projects: { title: "近期專案", sub: "南加州真實的安裝與維修案例。" },
    reviews: { title: "客戶評價", sub: "南加州屋主的真實回饋。" },
    specials: { title: "特別優惠", sub: "限時促銷活動。" },
    membership: { title: "保養會員", sub: "優先服務，更省電費，更長壽命。" },
    areas: { title: "服務區域", sub: "服務整個南加州。" },
    faq: { title: "常見問題" },
    contact: { title: "聯絡我們", sub: "電話、簡訊或表單 — 我們快速回應。" },
  },
  ko: {
    nav: { home: "홈", services: "서비스", brands: "브랜드", pricing: "가격", specials: "특가", projects: "프로젝트", reviews: "후기", areas: "서비스 지역", about: "회사 소개", schedule: "예약", contact: "문의" },
    cta: { call: "지금 전화", schedule: "서비스 예약", estimate: "무료 견적", text: "문자 보내기" },
    hero: { h1: "빠르고 신뢰할 수 있는 수리 & 설치.", sub: "지역 업체. 보험 완비. 전문 기사. 무료 견적.", badges: ["면허 & 보험","당일 서비스","24/7 긴급","주거 & 상업"] },
    emergency: "24/7 긴급 HVAC 서비스 이용 가능",
    emergency_sub: "영업시간 외 출장비 없음.",
    why: { title: "AIR-COLD HVAC를 선택하는 이유", sub: "프리미엄 서비스. 정직한 가격. 진짜 사람이 전화를 받습니다." },
    services: { title: "서비스", sub: "주거 및 상업용 HVAC — 한 번에 제대로." },
    brands: { title: "모든 주요 HVAC 브랜드", sub: "모든 주요 브랜드를 설치, 수리, 정비합니다." },
    pricing: { title: "투명한 장비 가격", sub: "숨겨진 비용 없음. 전화 전에 장비 옵션을 확인하세요." },
    estimate: { title: "즉시 견적", sub: "집에 대해 알려주시면 몇 초 안에 가격대를 받아보세요." },
    projects: { title: "최근 프로젝트", sub: "남부 캘리포니아 전역의 실제 설치 및 수리." },
    reviews: { title: "고객 후기", sub: "남부 캘리포니아 주택 소유자들의 실제 후기." },
    specials: { title: "특별 할인", sub: "설치, 수리, 정비에 대한 기간 한정 프로모션." },
    membership: { title: "정비 멤버십", sub: "우선 서비스. 더 낮은 비용. 더 긴 시스템 수명." },
    areas: { title: "서비스 지역", sub: "남부 캘리포니아 전 지역을 자랑스럽게 서비스합니다." },
    faq: { title: "자주 묻는 질문" },
    contact: { title: "문의하기", sub: "전화, 문자 또는 양식 — 빠르게 답변드립니다." },
  },
  vi: {
    nav: { home: "Trang Chủ", services: "Dịch Vụ", brands: "Thương Hiệu", pricing: "Giá Cả", specials: "Ưu Đãi", projects: "Dự Án", reviews: "Đánh Giá", areas: "Khu Vực", about: "Giới Thiệu", schedule: "Đặt Lịch", contact: "Liên Hệ" },
    cta: { call: "Gọi Ngay", schedule: "Đặt Lịch Dịch Vụ", estimate: "Báo Giá Miễn Phí", text: "Nhắn Tin" },
    hero: { h1: "NHANH CHÓNG. SỬA CHỮA & LẮP ĐẶT ĐÁNG TIN CẬY.", sub: "Địa phương. Có bảo hiểm. Kỹ thuật viên chuyên nghiệp. Báo giá miễn phí.", badges: ["Có Giấy Phép & Bảo Hiểm","Dịch Vụ Trong Ngày","Khẩn Cấp 24/7","Nhà Ở & Thương Mại"] },
    emergency: "Dịch Vụ HVAC Khẩn Cấp 24/7",
    emergency_sub: "Không tính phí gọi ngoài giờ.",
    why: { title: "Vì sao chọn AIR-COLD HVAC", sub: "Dịch vụ cao cấp. Giá trung thực. Người thật trả lời điện thoại." },
    services: { title: "Dịch Vụ", sub: "HVAC dân dụng và thương mại — làm đúng ngay từ lần đầu." },
    brands: { title: "Tất Cả Các Thương Hiệu HVAC Lớn", sub: "Chúng tôi lắp đặt, sửa chữa và bảo trì mọi thương hiệu HVAC chính." },
    pricing: { title: "Giá Thiết Bị Minh Bạch", sub: "Không Giá Ẩn. Biết Tùy Chọn Thiết Bị Trước Khi Gọi." },
    estimate: { title: "Báo Giá Tức Thì", sub: "Cho chúng tôi biết về ngôi nhà của bạn và nhận khoảng giá trong vài giây." },
    projects: { title: "Dự Án Gần Đây", sub: "Các công trình lắp đặt và sửa chữa thực tế khắp Nam California." },
    reviews: { title: "Đánh Giá Của Khách Hàng", sub: "Phản hồi thực tế từ chủ nhà Nam California." },
    specials: { title: "Ưu Đãi Đặc Biệt", sub: "Khuyến mãi có thời hạn về lắp đặt, sửa chữa và bảo trì." },
    membership: { title: "Gói Bảo Trì Thành Viên", sub: "Ưu tiên phục vụ. Hóa đơn thấp hơn. Hệ thống bền lâu hơn." },
    areas: { title: "Khu Vực Phục Vụ", sub: "Tự hào phục vụ khắp Nam California." },
    faq: { title: "Câu Hỏi Thường Gặp" },
    contact: { title: "Liên Hệ", sub: "Gọi điện, nhắn tin hoặc điền vào biểu mẫu — chúng tôi phản hồi nhanh." },
  },
  ja: {
    nav: { home: "ホーム", services: "サービス", brands: "ブランド", pricing: "料金", specials: "特別オファー", projects: "施工事例", reviews: "お客様の声", areas: "対応エリア", about: "私たちについて", schedule: "予約", contact: "お問い合わせ" },
    cta: { call: "今すぐ電話", schedule: "サービス予約", estimate: "無料お見積り", text: "テキスト送信" },
    hero: { h1: "迅速。信頼の修理＆設置。", sub: "地元密着。保険完備。専門技術者。無料見積もり。", badges: ["免許＆保険","当日対応","24時間緊急対応","住宅＆商業"] },
    emergency: "24時間緊急HVACサービス対応中",
    emergency_sub: "営業時間外の出張料無料。",
    why: { title: "AIR-COLD HVACが選ばれる理由", sub: "プレミアムサービス。正直な価格。実在のスタッフが電話に応対。" },
    services: { title: "サービス", sub: "住宅・商業向けHVAC — 一度で完璧に。" },
    brands: { title: "主要HVACブランド全対応", sub: "主要HVACブランドすべての設置、修理、メンテナンス。" },
    pricing: { title: "透明な機器価格", sub: "隠れた価格なし。お電話前に機器の選択肢をご確認ください。" },
    estimate: { title: "瞬時お見積り", sub: "ご自宅の情報を入力し、数秒で価格レンジをご確認。" },
    projects: { title: "最近の施工事例", sub: "南カリフォルニア全域の実際の設置と修理。" },
    reviews: { title: "お客様の声", sub: "南カリフォルニアのお客様からの本物のフィードバック。" },
    specials: { title: "特別オファー", sub: "設置、修理、メンテナンスの期間限定キャンペーン。" },
    membership: { title: "メンテナンス会員", sub: "優先サービス。請求書削減。システム寿命延長。" },
    areas: { title: "対応エリア", sub: "南カリフォルニア全域に自信を持って対応しています。" },
    faq: { title: "よくあるご質問" },
    contact: { title: "お問い合わせ", sub: "電話、テキスト、またはフォーム — すぐに対応いたします。" },
  },
  ar: {
    nav: { home: "الرئيسية", services: "الخدمات", brands: "العلامات التجارية", pricing: "الأسعار", specials: "العروض", projects: "المشاريع", reviews: "التقييمات", areas: "مناطق الخدمة", about: "من نحن", schedule: "احجز", contact: "اتصل" },
    cta: { call: "اتصل الآن", schedule: "احجز خدمة", estimate: "تقدير مجاني", text: "أرسل رسالة نصية" },
    hero: { h1: "سريع. إصلاحات وتركيبات موثوقة.", sub: "محلي. مؤمَّن. فنيون خبراء. تقديرات مجانية.", badges: ["مرخص ومؤمَّن","خدمة في نفس اليوم","حالات الطوارئ 24/7","سكني وتجاري"] },
    emergency: "خدمة HVAC طارئة على مدار الساعة",
    emergency_sub: "بدون رسوم خدمة بعد ساعات العمل.",
    why: { title: "لماذا تختار AIR-COLD HVAC", sub: "خدمة متميزة. أسعار صادقة. أشخاص حقيقيون يردون على الهاتف." },
    services: { title: "الخدمات", sub: "أنظمة HVAC للمنازل والمنشآت التجارية — بالشكل الصحيح من أول مرة." },
    brands: { title: "جميع العلامات التجارية الرئيسية لـ HVAC", sub: "نقوم بتركيب وإصلاح وصيانة كل العلامات التجارية الكبرى." },
    pricing: { title: "أسعار شفافة للمعدات", sub: "لا أسعار خفية. اعرف خيارات المعدات قبل الاتصال." },
    estimate: { title: "تقدير فوري", sub: "أخبرنا عن منزلك واحصل على نطاق سعري في ثوانٍ." },
    projects: { title: "المشاريع الأخيرة", sub: "تركيبات وإصلاحات حقيقية في جنوب كاليفورنيا." },
    reviews: { title: "تقييمات العملاء", sub: "تقييمات حقيقية من أصحاب المنازل في جنوب كاليفورنيا." },
    specials: { title: "العروض الخاصة", sub: "عروض ترويجية محدودة المدة على التركيب والإصلاح والصيانة." },
    membership: { title: "عضوية الصيانة", sub: "خدمة بأولوية. فواتير أقل. عمر أطول للنظام." },
    areas: { title: "مناطق الخدمة", sub: "نخدم بفخر جميع أنحاء جنوب كاليفورنيا." },
    faq: { title: "الأسئلة الشائعة" },
    contact: { title: "تواصل معنا", sub: "اتصل أو راسلنا أو املأ نموذجاً — نرد بسرعة." },
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ac_lang") || "en");
  useEffect(() => { localStorage.setItem("ac_lang", lang); document.documentElement.lang = lang; document.documentElement.dir = lang === "ar" ? "rtl" : "ltr"; }, [lang]);
  const t = useCallback((path) => {
    const code = T[lang] ? lang : "en";
    const dict = T[code];
    const parts = path.split(".");
    let cur = dict;
    for (const p of parts) { cur = cur?.[p]; if (cur === undefined) break; }
    if (cur === undefined) {
      let en = T.en; for (const p of parts) { en = en?.[p]; if (en === undefined) break; }
      return en ?? path;
    }
    return cur;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
}
